import { render, staticRenderFns } from "./SurveyTimer.vue?vue&type=template&id=e395e89a&"
import script from "./SurveyTimer.vue?vue&type=script&lang=ts&"
export * from "./SurveyTimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports